module.exports = __webpack_public_path__ + "static/media/complaint-email-icon.fe00866e.svg";